export default function PieIcon7030Small() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.00001" cy="7.99992" r="6.47413" fill="#E77F7E" fillOpacity="0.25" />
      <path
        d="M8 1.52583C6.80603 1.52583 5.63531 1.85601 4.61727 2.47986C3.59924 3.10371 2.77356 3.99693 2.2315 5.06077C1.68945 6.12461 1.45214 7.31763 1.54582 8.50792C1.6395 9.69822 2.06051 10.8394 2.76231 11.8054C3.46411 12.7713 4.41936 13.5244 5.52245 13.9813C6.62554 14.4382 7.8335 14.5812 9.01278 14.3944C10.1921 14.2076 11.2967 13.6984 12.2046 12.9229C13.1125 12.1475 13.7883 11.1361 14.1573 10.0006L8 7.99997L8 1.52583Z"
        fill="#E77F7E"
      />
    </svg>
  );
}
